import React, { useEffect, useRef, useState, useCallback } from "react";
import PropTypes from "prop-types";
import style from "./PatientDiary.module.sass";
import Button from "../../Button/Button";
import List from "../../List/List";
import DiaryEntry from "./DiaryEntry/DiaryEntry";
import EntryForm from "./EntryForm/EntryForm";
import { debounce } from "../../../helpers";

function PatientDiary(props) {
  const { newEntryPath, newEntryLabel, entriesPath, filters, translations } = props;
  const [filterStatus, setFilterStatus] = useState('pending');
  const [filterAlerts, setFilterAlerts] = useState([]);
  const [reloadKey, setReloadKey] = useState(0);

  const buildQuery = (status, alerts, withRandom = false) => {
    let query = `${entriesPath}?filter_status=${status}`;

    if (alerts.length > 0) {
      query += `&filter_alert_level=${alerts.join(",")}`;
    }

    if (withRandom) {
      query += `&random=${crypto.randomUUID()}`;
    }

    return query;
  };

  const onManage = () => {
    refreshList();
  };

  const onSubmit = () => {
    refreshList();
  };

  const refreshList = () => {
    setReloadKey(prev => prev + 1);
  };

  const renderDiaryEntry = (item) => {
    return (
      <DiaryEntry key={item.id} {...item} onManage={onManage} />
    );
  };

  const handleFilterStatusChange = (e) => {
    setFilterStatus(e.target.value);
  };

  const renderOptions = (options) => {
    return options.map((option) => {
      return (
        <option key={option.key} value={option.key}>
          {option.label}
        </option>
      );
    });
  };

  const toggleAlert = (level) => {
    setFilterAlerts(prev => {
      if (prev.includes(level)) {
        return prev.filter(l => l !== level);
      } else {
        return [...prev, level];
      }
    });
  };

  return (
    <div className={style.PatientDiary}>
      <div className={style.header}>
        <div className={style.filterStatus}>
          <div className={`d-flex text-end`}>
            <i className={`fa fa-filter ${style.iconFilter}`}></i>
            <select
              id="educational-video-order-by"
              className={"select kari-select ps-5"}
              value={filterStatus}
              onChange={handleFilterStatusChange}
            >
              {renderOptions(filters.status)}
            </select>
            <i
              className={`fa fa-angle-down ${style.iconOrder}`}
            ></i>
          </div>
        </div>
        <div className={style.filterAlert}>
          <div className={style.filterAlert}>
            <div className={style.alertToggle}>
              <div
                className={`${style.alertButton} ${filterAlerts.includes("yellow") ? style.active : ""}`}
                onClick={() => toggleAlert("yellow")}
              >
                ⚠️
              </div>

              <div
                className={`${style.alertButton} ${filterAlerts.includes("red") ? style.active : ""}`}
                onClick={() => toggleAlert("red")}
              >
                🚨
              </div>
            </div>
          </div>
        </div>
      </div>
      <EntryForm
        newEntryPath={newEntryPath}
        onSubmit={onSubmit}
        translations={translations.entryForm}
      />
      <div className={style.entries}>
        <List
          key={reloadKey} // forza refresh manuale
          baseQuery={buildQuery(filterStatus, filterAlerts, true)}
          renderItem={renderDiaryEntry}
          showPagination={false}
        />
      </div>
    </div>
  );
}

PatientDiary.propTypes = {
  path: PropTypes.string,
};

export default PatientDiary;
